import React, { useContext, useEffect, useState } from "react";
import { Box, Grid, TablePagination, Typography } from "@mui/material";
import Heading from "../../Components/Common/Heading";
import Container from "../../Components/Layout/Container";
import BookingsCard from "../../Components/MyBookings/BookingsCard";
import Navbar from "../../Components/Common/Navbar";
import Footer from "../../Components/Common/Footer";
import axios from "axios";
import { BASE_URL } from "../../Assets/Constants";
import { CurrencyContext } from "../../Services/CurrencyContext";
import { useTheme } from "@emotion/react";

function MyBookings() {
  const themes = useTheme();
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const { currency } = useContext(CurrencyContext);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);

  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const token = loginData?.token;

  const fetchBookings = () => {
    if (token) {
      axios
        .get(`${BASE_URL}/user/bookings`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          const sortedBookings = response.data.data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setBookings(sortedBookings);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching bookings:", error);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings(); 

    const interval = setInterval(() => {
      fetchBookings();
    }, 3000); 

    return () => clearInterval(interval);
  }, [token, currency]);

  if (loading) {
    return (
      <>
        <style>{loaderStyle.spinnerAnimation}</style>
        <div style={loaderStyle.loaderContainer}>
          <div style={loaderStyle.spinner}></div>
        </div>
      </>
    );
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const paginatedData = bookings.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <>
      <Navbar currency={currency} />{" "}
      <Box>
        <Box textAlign={"center"} my={5}>
          <Heading label={"My Bookings"} />
        </Box>
        <Container>
          <Box
            sx={{
              minHeight: "100vh",
            }}
          >
            {token ? (
              paginatedData && paginatedData.length > 0 ? (
                <Grid container spacing={2}>
                  {paginatedData.map((booking) => (
                    <Grid item xs={12} key={booking._id}>
                      <BookingsCard booking={booking} refreshBookings={fetchBookings}  />
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Box textAlign="center" mt={2}>
                  No data available right now.
                </Box>
              )
            ) : (
              <Box textAlign="center" my={5}>
                <Typography sx={{ fontSize: "34px" }}>Login to see bookings</Typography>
              </Box>
            )}

            <TablePagination
              rowsPerPage={rowsPerPage}
              page={page}
              count={bookings?.length}
              component="div"
              onPageChange={handleChangePage}
              sx={{
                "& .MuiSelect-icon": {
                  display: "none",
                },
                "& .MuiTablePagination-toolbar": {
                  display: "flex",
                  justifyContent: "flex-end",
                },
                "& .MuiTablePagination-selectLabel, & .MuiTablePagination-select, & .css-1brww8i-MuiInputBase-root-MuiTablePagination-select":
                {
                  display: "none",
                },
                "& .MuiTablePagination-actions button:enabled": {
                  color: themes.colors.orange,
                },
              }}
            />
          </Box>
        </Container>
      </Box>
      <Footer />
    </>
  );
}

const loaderStyle = {
  loaderContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f9f9f9",
  },
  spinner: {
    width: "50px",
    height: "50px",
    border: "5px solid rgba(0, 0, 0, 0.1)",
    borderTop: "5px solid #FF7900",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  spinnerAnimation: `
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `,
};

export default MyBookings;
